import API from "../../../services/API";
import { useState, useEffect } from "react";
import Loader from "../../Tools/Loader";
import { txt } from "../../../services/translation";

export default function Pdf({section}){

    const [url, setUrl] = useState(null)

    useEffect(() => {

        const url = API.url(`/study/sections/${section.id}/doc.pdf`);
        setUrl(url);

        return () => setUrl(null)

    }, [section])
    

    const handleLoad = e => {
        const iframe = e.target;
        const img = iframe ? iframe.contentWindow.document.getElementsByTagName("img")[0] : null;
        if(img){ img.style.width = "100%" }
    }


    if(!url) return <Loader />

    return <iframe 
        title={section.title}
        width="100%" 
        height="99%" 
        src={url}
        frameBorder="0" 
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
        allowFullScreen={true}
        onLoad={handleLoad}
    >
        {txt('unavailableContent')}
    </iframe>


}